import { Search } from "../common/search";
import { Multilingua } from "../model/multilingua";
import { MultilinguaService } from "../service/multilingua.service";
import { MenuService } from "../service/menu.service";
import { Attivita } from "../model/attivita";
import { SeoService } from "../service/seo.service";
import { DOCS_REPLACE } from "./constants";

function getAttivita() {
  this.attivitaService.search = new Search<Attivita>(Attivita);
  this.attivitaService.search._.lang = this.lingua;
  this.attivitaService.getAllList().subscribe((attivitas) => {
    this.attivitas = attivitas;
    for (const all of this.attivitas) {
      this.allegatoService.find(all.immagine_lancio).subscribe((attach) => {
        if (attach) {
          all.path_immagine = DOCS_REPLACE(attach.uuid);
          this.seoService.setImage(all.path_immagine);
        }
      });
    }
  });
}

function getOtherLangs(
  multilingueService: MultilinguaService,
  lingua: string,
  menuService: MenuService,
  seoService: SeoService,
  pageName: string
) {
  multilingueService.search = new Search<Multilingua>(Multilingua);
  // seoService.setLang(lingua);
  if (lingua === "IT") {
    // seoService.setTitle('Servizi Italia nel Mondo');
    multilingueService.search._.it = pageName;
  } else if (lingua === "EN") {
    // seoService.setTitle('Servizi Italia in the World');
    multilingueService.search._.eng = pageName;
  } else if (lingua === "PT") {
    // seoService.setTitle('Servizi Italia in the World');
    multilingueService.search._.pt = pageName;
  }
  multilingueService.getList().subscribe((link) => {
    // console.log('link trovato: ' + link);
    const lingue = [];
    if (link.length > 0) {
      if (lingua === "EN" && link[0].it) {
        lingue.push("IT");
      }
      if (lingua === "IT" && link[0].eng) {
        lingue.push("EN");
      }
      if (lingua === "PT" && link[0].pt) {
        lingue.push("EN");
      }
    }
    menuService.add(lingue);
  });
}

export { getOtherLangs };
export { getAttivita };
